/** Labels created per animation frame during bulk upsert to avoid main-thread freeze. */
export const TEXT_UPSERT_BATCH_SIZE = 75;

export function yieldToMainThread(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => resolve());
  });
}
